
export const employersFrag = `
  employers {
    name
    employerVariableSymbol
    employmentId
    employmentFrom
    address {
      name
      location
      position {
        lon
        lat
      }
      regionalStructure {
        name
        type
        isoCode
      }
      zip
    }
  }
`;

export const folderSickNotesFillingFrag = `
    id
    createdAt
    folderSickNoteId
    sent
    fillingId
    fillingType
    fillingState
    correctiveFilling
    decisionNumber
`;

export const folderSickNotesEventsFrag = `
    id
    folderSickNoteId
    event
    csszEventTime
    decisionNumber
    fillingId
    fillingType
    note
`;

export const folderSickNoteFrag = `
    id
    folderId
    sszCode
    insuranceAdministrator
    decisionNumber
    name
    surname
    titles
    phone
    email
    insuranceNumber
    birthDate
    address {
        name
        location
        position {
            lon
            lat
        }
        regionalStructure {
            name
            type
            isoCode
        }
        zip
    }
    addition
    employmentId
    employerName
    employerVariableSymbol
    profession
    employerAddress {
        name
        location
        position {
            lon
            lat
        }
        regionalStructure {
            name
            type
            isoCode
        }
        zip
    }
    issueDate
    issueEndDate
    confirmationDurationDate
    incapacityStartDate
    incapacityEndDate
    confirmationIssueDate
    diagnosisCode
    doctorOrigin
    doctorOriginIcpe
    doctorActual
    doctorActualIcpe
    confirmingDoctor
    confirmingDoctorIcpe
    decidingDoctor
    decidingDoctorIcpe
    walkoutsFromDate
    walkoutsFrom1
    walkoutsTo1
    walkoutsFrom2
    walkoutsTo2
    walkoutsIndividual
    injury
    workInjury
    injuryFromAnotherPerson
    usingAlcoholOrDrugs
    controlDate
    state
    closed
    events {
        ${folderSickNotesEventsFrag}
    }
`;

export const folderOtherSickNoteListFrag = `
    sickNotes {
       decisionNumber
       icpe
       namePzs
       doctorName
       insuranceNumber
       name
       surname
       issueDate
       state
    }    
`;
